import { Button, Center, Flex, Text } from '@chakra-ui/react';
import { Modal } from '@gamma/ui/overlay';
import { GraphQLReqStatus } from '@gamma/ui/progress';
import { TopFeatureContributions } from '@investigator/shared/components';
import { useEntityMLContributions } from '@investigator/shared/hooks';
import { i18n } from '@investigator/shared/localization';
import { EntityVsPopChart } from '../../../../../../../../../../../entities/components';
import { SanitizedMlAlert } from '../../DetectionAlerts';
import { ModelSummaryFeature } from '@investigator/features/detections/queries/types';

interface MLAnalysisModalProps {
  item: SanitizedMlAlert;
}

export const MLAnalysisModal = ({ item }: MLAnalysisModalProps) => {
  const { buttons } = i18n.pages.entityDetails;
  const { alerts } = i18n.pages.detections;

  const { isLoading, error, contributions } = useEntityMLContributions({
    pipeline: item?.pipeline,
    models: item?.models?.map((model) => ({
      ...model,
      features: (model.features ?? []).filter(Boolean) as ModelSummaryFeature[],
    })),
  });

  if (isLoading || error) {
    return (
      <Center w="100%">
        <GraphQLReqStatus error={error} loading={isLoading} />
      </Center>
    );
  }

  return (
    <span data-testid="ml-alerts-wrapper">
      <Flex flexGrow={1}>
        <Modal
          title={alerts.ml.mlAnalysis}
          size="xl"
          body={
            <Flex data-testid="ml-analysis-content">
              <TopFeatureContributions features={contributions} />
              <EntityVsPopChart alertData={item} features={contributions} />
            </Flex>
          }
        >
          <Button
            variant="solid"
            colorScheme="gray"
            aria-label={buttons.mlAnalysis}
            marginLeft={2}
            data-testid="ml-analysis-button"
          >
            <Text fontSize="small" px={1}>
              {buttons.mlAnalysis}
            </Text>
          </Button>
        </Modal>
      </Flex>
    </span>
  );
};
